import React from "react";

export default ({ color = "#FFF", grey = false }) => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        d="M11 5.007v7a1 1 0 01-2 0v-7a1 1 0 012 0zm0 10a1 1 0 11-2 0 1 1 0 012 0zM18 17a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v14zm0-17H2C.895 0 0 .899 0 2.003v16.004C0 19.112.895 20 2 20h16c1.105 0 2-.892 2-1.997V2.007C20 .902 19 0 18 0z"
        id="a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use href="#a" />
      </mask>
      <use fillOpacity="0" fill="#FFF" href="#a" />
      <g mask="url(#b)" fill={grey ? "#CCCDD1" : color}>
        <path d="M-1-1h22v22H-1z" />
      </g>
    </g>
  </svg>
);
